import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import Alerts from "../util/Alerts";
import axios from "axios";
import { routes } from "../gen/General";
import { useSelector } from "react-redux";
import { AcordeonPoliza } from "./AcordeonPoliza";
import { useHistory } from "react-router-dom";
import asistente from "../assets/img/asistente.png";
import cerrar from "../assets/img/icon/icon_cerrar.svg";
import activa from "../assets/img/icon/icon_seccion_activa.svg";
import inactiva from "../assets/img/icon/icon_seccion_inactiva.svg";

export const ComponentPolizas = props => {
    const user = useSelector(state => state.user);
    const [list, setList] = useState([]);
    const alert = React.useRef(null);

    useEffect(() => {
        let tp = props.match.params.tp;
        if (tp === "vam") {
            getAseguradoraVam(user.cedula);
        } else {
            getAseguradora(user.cdCliente);
            // getAseguradora(8128);
        }
    }, [props.match.params.tp, user]);

    const getAseguradoraVam = param => {
        if (param) {
            axios
                .get(routes.apiVam + "/siniestro/deducible/matrix", {
                    params: {
                        cedula: param,
                        caducada: true,
                    },
                })
                .then(resp => {
                    setList(resp.data);
                })
                .catch(error => {
                    alert.current.handle_error(error);
                });
        }
    };

    const getAseguradora = param => {
        if (param) {
            axios
                .get(routes.api + "/siniestro/aseguradora", {
                    params: {
                        cdCompania: 1,
                        cdCliente: param, //pasar en el componente el siniestro
                        caducada: true,
                    },
                })
                .then(resp => {
                    setList(resp.data);
                })
                .catch(error => {
                    alert.current.handle_error(error);
                });
        }
    };

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Row>
                <Col xs={12}>
                    <Card>
                        <SeccionHeader idx={1} />
                        <div className="row justify-content-end">
                            <SeccionSalir to={"/" + props.match.params.tp + "/polizas"} />
                        </div>
                        <Row>
                            <Col md={7}>
                                <h4 className="my-4 titulos">Prestadores:</h4>
                            </Col>
                        </Row>
                        <CardBody>
                            <div className="container">
                                <Row>
                                    <Col md={7} className={"p-0"}>
                                        <Row className={"justify-content-end d-none d-md-flex"}>
                                            <Col md={10}>
                                                <span className={"text-primary"}>
                                                    {
                                                        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat."
                                                    }
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row className="d-flex d-md-none">
                                            <div className={"col-9"}>
                                                <span className={"text-primary"}>
                                                    {
                                                        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat."
                                                    }
                                                </span>
                                            </div>
                                            <div className={"col text-right"}>
                                                {list.length > 0 && (
                                                    <img
                                                        src={asistente}
                                                        alt={"Asistente"}
                                                        style={{ maxHeight: "700px" }}
                                                    />
                                                )}
                                            </div>
                                        </Row>
                                        <Row className={"text-primary my-5 justify-content-end"}>
                                            <Col md={10}>
                                                <span className={"my-5 h6"}>
                                                    {list.length > 0
                                                        ? "Seleccione su Póliza"
                                                        : "No se encontraron pólizas"}
                                                </span>
                                                {(list || []).map((poliza, index) => (
                                                    <div key={index}>
                                                        <AcordeonPoliza
                                                            poliza={poliza}
                                                            index={index}
                                                            tp={props.match.params.tp}
                                                        />
                                                    </div>
                                                ))}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <div className="col" />
                                    <Col md={3} className={"text-right d-none d-md-block"}>
                                        {list.length > 0 && (
                                            <img src={asistente} alt={"Asistente"} style={{ maxHeight: "700px" }} />
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export const SeccionHeader = ({ idx }) => {
    return (
        <>
            <div className="col-12">
                <div className="seccion-poliza">
                    <span>
                        Sección <b>0{idx}</b> / 03
                    </span>
                    <div>
                        <img src={idx == 1 ? activa : inactiva} alt="" width={"25"} />
                        &nbsp;
                        <img src={idx == 2 ? activa : inactiva} alt="" width={"25"} />
                        &nbsp;
                        <img src={idx == 3 ? activa : inactiva} alt="" width={"25"} />
                    </div>
                </div>
            </div>
        </>
    );
};

export const SeccionSalir = ({ to }) => {
    const history = useHistory();

    return (
        <>
            <div className="back-button justify-content-center title py-1">
                <button
                    type="button"
                    className="close py-0"
                    title="Salir"
                    onClick={() => history.push(to)}
                    aria-label="Close"
                >
                    <span aria-hidden="true">
                        <img src={cerrar} alt="" width={"12"} />
                    </span>
                </button>
            </div>
        </>
    );
};
